module.exports = __webpack_public_path__ + "static/media/Recovery.2ffc253e.svg";